import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import Api from '../../../helpers/api';
import { t } from '../../../i18n';

const api = new Api('unmatched_reasons');
const feedbackApi = new Api('unmatched_reasons/:id');

function* loadData() {
  try {
    const result = yield call(sendRequest, api.load, {}, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result;

      yield put(actions.loadDataSuccess({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* deleteClient(data) {
  try {
    const { payload } = data;
    const { id } = payload;

    const result = yield call(sendRequest, feedbackApi.deleteItem, { id }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      yield loadData();
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.deleted_successfully', {
            item: t('dash.admin.unmatchOptions.unmatched_option_title'),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData };
export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.DELETE, deleteClient)]);
}
